/*
 * <collection-scroller> — the ONLY JS in Collections pro.
 * Native horizontal scroll (swipe / trackpad) needs no JS; this just wires the
 * optional prev/next arrows to a smooth programmatic scroll and disables them at
 * the ends. The right-edge fog and all animations are pure CSS. No dependencies.
 */
if (!customElements.get('collection-scroller')) {
  customElements.define(
    'collection-scroller',
    class CollectionScroller extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.clist__scroller');
        this.track = this.querySelector('.clist__track');
        this.prev = this.querySelector('.clist__arrow--prev');
        this.next = this.querySelector('.clist__arrow--next');
        if (!this.scroller) return;

        this.prev?.addEventListener('click', () => this.scrollByCards(-1));
        this.next?.addEventListener('click', () => this.scrollByCards(1));
        this.scroller.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update(), { passive: true });
        this.update();
      }

      step() {
        const card = this.track?.querySelector('.clist__card');
        const gap = this.track ? parseFloat(getComputedStyle(this.track).columnGap) || 0 : 0;
        return card ? card.getBoundingClientRect().width + gap : this.scroller.clientWidth * 0.8;
      }

      scrollByCards(dir) {
        this.scroller.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }

      update() {
        if (!this.prev || !this.next) return;
        const max = this.scroller.scrollWidth - this.scroller.clientWidth - 1;
        this.prev.disabled = this.scroller.scrollLeft <= 0;
        this.next.disabled = this.scroller.scrollLeft >= max;
      }
    }
  );
}
